import { Component, computed, effect, input, InputSignal, Signal } from '@angular/core';

@Component({
  selector: 'app-labels-cell',
  imports: [],
  template: `
    <div class="labels-container">
      @if (count() === 0) {
        <div>-</div>
      } @else {
        @for (label of visibleLabels(); track $index) {
          <div class="label">{{ label }}</div>
        }
        @if (hiddenLabelCount() > 0) {
          <div class="label">+{{ hiddenLabelCount() }}</div>
        }
      }
    </div>
  `,
  styleUrl: './labels-cell.scss',
})
export class LabelsCell {
  labels: InputSignal<string[]> = input.required<string[]>();
  visibleLabels: Signal<string[]> = computed(
    () =>
      this.labels()
        .sort((a: string, b: string) => a.length - b.length)
        .slice(0, 2) || [],
  );
  count: Signal<number> = computed(() => this.labels().length);
  hiddenLabelCount: Signal<number> = computed(() => this.count() - this.visibleLabels().length);
}
